import { type Company } from 'src/shared/types/company';

export const formatMultipleSelected =
  (data: Array<{ label: unknown; value: string }>) =>
  (selected: string[]): string => {
    const filtered = data.filter(element => selected.includes(element.value)).map(el => el.label);
    return filtered.join(', ');
  };

export type FactorialValues = {
  id: string;
  company: string;
  secret: string;
  legalEntityId: string | undefined;
  teams: string[];
  leaves: string[];
  withCustomFields: boolean;
  customFields: Record<string, string | null | undefined> | null | undefined;
  selectAllLegalEntities: boolean;
};

export const factorialInitialValues: FactorialValues = {
  id: '',
  company: '',
  secret: '',
  legalEntityId: undefined,
  teams: [],
  leaves: [],
  withCustomFields: false,
  customFields: null,
  selectAllLegalEntities: false
};
